export const VENUS_DISCORD_URL = 'https://discord.gg/AK2AzvydUz';
export const VENUS_TWITTER_URL = 'https://x.com/EnclabsFi';
export const VENUS_GITHUB_URL = 'https://github.com/EnclabsTechIntern';
export const VENUS_TELEGRAM_URL = 'https://t.me/EnclabsFinance';
export const VENUS_DOC_URL = 'https://enclabs.gitbook.io/enclabs-documentation';